// extracted by mini-css-extract-plugin
export default {"root":"Progress_root__zEAPO","container":"Progress_container__0HImP","label":"Progress_label__4RLuK"};